import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewType } from '@ortho-next/nextray-core';
import { BaseComponent, ConfirmationComponent } from '../../shared';


/**
* Component of first vertical sidebar tool menu to handle deformity analysis.
*/
@Component({
	selector: 'deformity-menu',
	templateUrl: './deformity-menu.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class DeformityMenuComponent extends BaseComponent {

	private readonly modalSrv = inject(NgbModal);


	private openWarningModal(message: string, confirmFunction: Function, cancelFunction?: Function): void {
		if (!this.modalSrv.hasOpenModals()) {
			const modalRef = this.modalSrv.open(ConfirmationComponent, { centered: true, backdrop: 'static' });
			(modalRef.componentInstance as ConfirmationComponent).config = {
				title: this.labels().TOOLS_MENU_COMPONENT_WARNING_MODAL_TITLE,
				message: message
			};
			modalRef.result.then(() => confirmFunction.call(this), () => cancelFunction ? cancelFunction.call(this) : null).catch(error => false);
		}
	}

	/**
	* Display Deformity analysis menu tools.
	*/
	enableDeformity(): void {
		if (this.stateType === this.stateTypeEnum.calibrated) {
			this.goToDeformity();
		} else {
			const message: string = this.labels().TOOLS_MENU_COMPONENT_DEFORMITY_MODAL_MESSAGE;
			this.openWarningModal(message, this.goToDeformity);
		}
	}

	private goToDeformity(): void {
		this.canvasSrv.dispatch('switchToDeformity');
		this.canvasSrv.saveState();
	}

	/**
	* Check if contralateral button is enabled.
	*/
	get isCtrlEnabled(): boolean {
		return this.activeView === this.activeViewEnum.AP;
	}

	/**
	* Start mechanical axis insertion workflow.
	*/
	setMechanicalAxis(): void {
		this.startMechanicalAxisWorkflow();
	}

	/**
	* Start contralateral axis insertion workflow.
	*/
	setContralateralAxis(): void {
		if (this.isCtrlEnabled) {
			this.startContralateralAxisWorkflow();
		}
	}

	private startMechanicalAxisWorkflow(): void {
		if (this.activeView === ViewType.LT && this.isLongLeg) {
			this.canvasSrv.dispatch('startBoneTypeSelection');
		} else {
			this.canvasSrv.dispatch('mechanical-axes-btn');
		}
	}

	private startContralateralAxisWorkflow(): void {
		this.canvasSrv.dispatch('ma-to-ctrlateral');
	}

}
